module.exports = __webpack_public_path__ + "static/media/datacamp.40f3a30f.png";